import AddressIntl from './AddressIntl';

export { DEFAULT_VALUE } from './constants';

export default AddressIntl;
